// Polyfills for SSR

const isSSR = typeof window === 'undefined'

export const HTMLElement = isSSR ? Object : window.HTMLElement



// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/src/utils/ssr.js